export default {
  data() {
    return {
      data: {}
    }
  },
  props: {
    viewData: {
      type: Object,
      required: true
    },
    prev: {
      type: String
    }
  },
  methods: {
    validate() {
      this.$validator.validateAll()
        .then(answer => {
          if (this.photoTouch !== undefined) {
            this.photoTouch = true;
          }
          if (this.validateImg === undefined) {
            this.validateImg = true;
          }
          if (answer && this.validateImg) {
            if(this.$route.params.id !== undefined) {
              this.data.id = this.$route.params.id;
            }
            if (this.data.photo === '/img/photo.svg') {
              this.data.photo = '/img/stub.webp';
            }
            Object.assign(this.data, this.$route.params);
            if (this.viewData.disable) {
              this.data.status = 'inactive';
            }
            this.$store.dispatch(this.viewData.send, this.data)
              .then(res => {
                if (res.ok) {
                  this.$router.push({name: this.prev});
                }
              })
          }
        });
    },
    getData() {
      if (this.viewData.data !== undefined) {
        let params = {};
        Object.assign(params, this.$route.params);
        for (let key in params) {
          params[key] = decodeURI(params[key]);
        }
        this.$store.dispatch(this.viewData.data, params)
          .then(res => {
            if (res.body.photo !== undefined) {
              res.body.photo = process.env.VUE_APP_URL + res.body.photo;
              this.validateImg = '';
            }
            this.data = res.body;
            this.$emit('loadTrue');
          });
      }
      else {
        this.$emit('loadTrue');
      }
    }
  },
  created() {
    this.getData();
    if (this.$route.name === 'generations-edit' || this.$route.name === 'generations-new') {
      this.$set(this.data, 'end', '');
      this.$set(this.data, 'start', '');
    }
  }
}